export const CLOSED_OPPORTUNITY = "CLOSED_OPPORTUNITY";
export const CLOSED_OPPORTUNITY_ERROR = "CLOSED_OPPORTUNITY_ERROR";
export const OPEN_OPPORTUNITY = "OPEN_OPPORTUNITY";
export const OPEN_OPPORTUNITY_ERROR = "OPEN_OPPORTUNITY_ERROR";
export const DASHBOARD_GROUPED_COUNT = "DASHBOARD_GROUPED_COUNT";
export const DASHBOARD_GROUPED_COUNT_ERROR = "DASHBOARD_GROUPED_COUNT_ERROR";
export const DASHBOARD_SALES_TREND = "DASHBOARD_SALES_TREND";
export const DASHBOARD_SALES_TREND_ERROR = "DASHBOARD_SALES_TREND_ERROR";
export const DASHBOARD_GROUPED_BYSOURCE = "DASHBOARD_GROUPED_BYSOURCE";
export const DASHBOARD_GROUPED_BYSOURCE_ERROR =
  "DASHBOARD_GROUPED_BYSOURCE_ERROR";
export const DASHBOARD_GROUPED_BYINDUSTRY = "DASHBOARD_GROUPED_BYINDUSTRY";
export const DASHBOARD_GROUPED_BYINDUSTRY_ERROR =
  "DASHBOARD_GROUPED_BYINDUSTRY_ERROR";
export const DASHBOARD_GROUPED_BYACTIVITY = "DASHBOARD_GROUPED_BYACTIVITY";
export const DASHBOARD_GROUPED_BYACTIVITY_ERROR =
  "DASHBOARD_GROUPED_BYACTIVITY_ERROR";
export const DASHBOARD_GROUPED_BY_EMAIL_ACTIVITY =
  "DASHBOARD_GROUPED_BY_EMAIL_ACTIVITY";
export const DASHBOARD_GROUPED_BY_EMAIL_ACTIVITY_ERROR =
  "DASHBOARD_GROUPED_BY_EMAIL_ACTIVITY_ERROR";
export const DASHBOARD_GROUPED_BY_MEETING_ACTIVITY =
  "DASHBOARD_GROUPED_BY_MEETING_ACTIVITY";
export const DASHBOARD_GROUPED_BY_MEETING_ACTIVITY_ERROR =
  "DASHBOARD_GROUPED_BY_MEETING_ACTIVITY_ERROR";
export const DASHBOARD_GROUPED_BY_CALL_ACTIVITY =
  "DASHBOARD_GROUPED_BY_CALL_ACTIVITY";
export const DASHBOARD_GROUPED_BY_CALL_ACTIVITY_ERROR =
  "DASHBOARD_GROUPED_BY_CALL_ACTIVITY_ERROR";

export const DASHBOARD_CONVERTED_LEADS = "DASHBOARD_CONVERTED_LEADS";
export const DASHBOARD_CONVERTED_LEADS_ERROR =
  "DASHBOARD_CONVERTED_LEADS_ERROR";

export const DASHBOARD_RECOMENDATION_COMPANY =
  "DASHBOARD_RECOMENDATION_COMPANY";
export const DASHBOARD_RECOMENDATION_COMPANY_ERROR =
  "DASHBOARD_RECOMENDATION_COMPANY_ERROR";
export const DASHBOARD_RECOMENDATION_EMPLOYEE =
  "DASHBOARD_RECOMENDATION_EMPLOYEE";
export const DASHBOARD_RECOMENDATION_EMPLOYEE_ERROR =
  "DASHBOARD_RECOMENDATION_EMPLOYEE_ERROR";

export const DASHBOARD_COMPANY_SAVED_SEARCH = "DASHBOARD_COMPANY_SAVED_SEARCH";
export const DASHBOARD_EXECUTIVE_SAVED_SEARCH =
  "DASHBOARD_EXECUTIVE_SAVED_SEARCH";

export const DASHBOARD_GROUPED_BYACTIVITY_STATUS =
  "DASHBOARD_GROUPED_BYACTIVITY_STATUS";
export const DASHBOARD_GROUPED_BYACTIVITY_STATUS_ERROR =
  "DASHBOARD_GROUPED_BYACTIVITY_STATUS_ERROR";
